import uri from 'urijs';
import Wix from '../services/wix-sdk-polyfill';
import { getConfig } from '../services/config';
import { MODAL_ROOT_PATH } from '@wix/communities-blog-client-common';

const MODAL_POSITION = {
  origin: Wix.WindowOrigin.FIXED,
  placement: Wix.WindowPlacement.CENTER,
};

export const openWixModal = (payload) => {
  return (dispatch, getState, { baseUrl }) => {
    const onClose = (data) => {
      const action = data && data.message;
      if (action) {
        dispatch(action);
      }
    };
    const data = JSON.stringify(payload);
    const debug = uri(window.location.search).search(true).debug;
    const url = `${baseUrl}${MODAL_ROOT_PATH}`;

    Wix.openPopup(
      `${url}?data=${data}&section-url=${getConfig().sectionUrl}&debug=${debug}`,
      '100%',
      '100%',
      MODAL_POSITION,
      onClose,
      Wix.Theme.BARE,
    );
  };
};
